import actions from './groupSelector/actions';
import getters from './groupSelector/getters';
import mutations from './groupSelector/mutations';

const state = {
  currentTab: null,
  group: null,
  groupDetailCk: null,
  groupDetailId: null,
  groups: [],
  groupSettings: null,
  hasSelection: false,
  // loginSubGroups: [],
  parentGroup: null,
  parentGroups: [],
  searchId: '',
  searchName: '',
  searching: false,
  searchResults: null,
  searchType: null,
  showSearch: false,
  subGroup: null,
  subGroupDetailCk: null,
  subGroups: [],
  tabs: ['parentGroup', 'group', 'subGroup'],
  tabsVisible: true,
  userHasOneParent: false,
  userHasTripleOnes: false
};

export const groupSelector = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
